import { AudioMath } from "../AudioMath";
import { MusicKey, MusicKeys } from "../music/MusicKey";
import { MusicNote } from "../music/MusicNote";

export class MidiKey
{
  static readonly C5 = MidiKey.fromPitch( 84 );
  static readonly C4 = MidiKey.fromPitch( 72 );
  static readonly C3 = MidiKey.fromPitch( 60 );
  static readonly C2 = MidiKey.fromPitch( 48 );
  static readonly C1 = MidiKey.fromPitch( 36 );
  static readonly C0 = MidiKey.fromPitch( 24 );

  static createRange( lowestKey:MidiKey, highestKey:MidiKey ):MidiKey[]
  {
    let range:MidiKey[] = [];

    for ( let i = lowestKey.pitch; i <= highestKey.pitch; i++ )
    {
      range.push( MidiKey.fromPitch( i ) );
    }

    return range;
  }

  _pitch:number;

  private constructor(){}

  get pitch() 
  {
    return this._pitch;
  }

  get frequency()
  {
    return AudioMath.midiKeyToFrequency( this._pitch );
  }

  get info()
  {
    return AudioMath.midiKeyToKeyInfo( this.pitch );
  }

  get keyName()
  {
    return AudioMath.midiKeyToKeyName( this.pitch );
  }

  get octave()
  {
    return AudioMath.midiKeyToKeyName( this.pitch );
  }

  moveSemitones( semitones:number )
  {
    return MidiKey.fromPitch( this._pitch + semitones );
  }

  stringifyToNote()
  {
    return MusicNote.fromMidiPitch( this.pitch ).toString();  
  }

  static fromPitch( value:number )
  {
    let m = new MidiKey();
    m._pitch = value;

    return m;
  }

  static fromNote( note:MusicNote )
  {
    let m = new MidiKey();
    m._pitch = note.midiPitch;

    return m;

  }





}